import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api, { CountryDto } from 'api';
import { RootState } from './rootReducer';

interface RegionState {
  countries: CountryDto[];
  isCountriesLoading: boolean;
}

const initialState: RegionState = {
  countries: [],
  isCountriesLoading: false,
};

export const getCountries = createAsyncThunk(
  'region/getCountries',
  async () => {
    return api.getCountries();
  },
  {
    condition: (_, { getState }) => {
      const { region } = getState() as RootState;

      return !region.countries.length;
    },
  },
);

const regionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCountries.fulfilled, (state, action) => {
      state.countries = action.payload;
      state.isCountriesLoading = false;
    });
    builder.addCase(getCountries.pending, (state, action) => {
      state.isCountriesLoading = true;
    });
    builder.addCase(getCountries.rejected, (state, action) => {
      state.isCountriesLoading = false;
    });
  },
});

const { reducer } = regionSlice;

export default reducer;
